export const SERVICE_CHARGE_RATE = 0.10;

export const roundSaleMoney = (value) => Math.round(Number(value || 0) * 100) / 100;

export const calculateServiceCharge = (restaurantSubtotal, discount, barSale, enabled) => {
  if (!enabled) return 0;
  const restaurantDiscount = barSale ? 0 : Number(discount || 0);
  return roundSaleMoney(Math.max(0, Number(restaurantSubtotal || 0) - restaurantDiscount) * SERVICE_CHARGE_RATE);
};
